import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { GenerateInterceptService } from 'src/app/auth/generate-intercept.service';
import { IdentificationResponse } from 'src/app/main/pages/services/microservices/response/identification.response';
import { MicroResponse } from 'src/app/main/pages/services/microservices/response/micro.response';
import { UserResponse } from 'src/app/main/pages/services/microservices/response/user.response';
import { environment } from 'src/environments/environment.test';

import { EconomicActivityJson } from './microservices/json/economic-activity.json';
import { UserRequest } from './microservices/request/user.request';
import { LockResponse } from './microservices/response/lock.response';
import { SimpleResponse } from './microservices/response/simple.response';

@Injectable()
export class UserService {
  private resourceUrl = environment.API_URL;

  // IMPLEMENTACION MICROSERVICIOS
  private identificationMicroservice = `${environment.IDEMPIER_GATEWAY}/v1/identification`;
  private userMicroservice = `${environment.IDEMPIER_GATEWAY}/v1/user`;
  private keycloakEndPont = environment.KEYCLOAK_USERS_ENDPOINT;
  private userResponse?: Observable<MicroResponse<UserResponse>>;
  private identificationResponse?: Observable<
    MicroResponse<IdentificationResponse>
  >;

  constructor(
    private _http: HttpClient,
    private _auth: GenerateInterceptService,
  ) {}

  // *MICROSERVICIOS
  getToken(): string {
    const token = localStorage.getItem('access_token');
    //return token;
    return '';
  }

  verifyUsernameKeycloak(email: string): Observable<any> {
    return this._http.get(`${this.keycloakEndPont}?username=${email}`);
  }

  checkInfo(username: string): Observable<MicroResponse<UserResponse>> {
    return this.getUserByEmail(username);
  }

  login(data: any): Observable<any> {
    return this._auth.getTokenAuth(data).pipe(response => {
      return response;
    });
  }

  addSession(data: any): Observable<MicroResponse<IdentificationResponse>> {
    return this.getUserByEmail(data.username).pipe(
      switchMap((userResponse: MicroResponse<UserResponse>) => {
        return this.getIdentificationById(userResponse.data.identificationId);
      }),
    );
  }

  searchCedula(
    cedula: string,
  ): Observable<MicroResponse<IdentificationResponse>> {
    return this.getIdentificationByCard(cedula);
  }

  buscarPerfilUsuario(param: any): Observable<MicroResponse<UserResponse>> {
    return this.getUserByIdentificationId(param);
  }

  buscarCelular(cellphone: string): Observable<any> {
    return this.verifyUserCell(cellphone);
  }

  buscarEmail(email: string): Observable<any> {
    return this.verifyUserEmail(email);
  }

  verifyFilters(
    cardId: string,
    filtersForm: any,
  ): Observable<MicroResponse<SimpleResponse>> {
    return this._http.post<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/verifyFilters?cardId=${cardId}`,
      filtersForm,
    );
  }

  verifyPinCodeUser(email: string, pinCode: string) {
    return this.verifyUserEmailPin(email, pinCode);
  }

  processPinAndMessage(
    email: string,
    pinCode: string,
  ): Observable<MicroResponse<SimpleResponse>> {
    return this._http.post<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/pin/email/${email}/message`,
      { pinCode: pinCode },
    );
  }

  sendEmail(params: any): Observable<MicroResponse<string>> {
    return this._http.post<MicroResponse<string>>(
      this.userMicroservice + `/${params}/email/message`,
      '',
    );
  }

  saveEmail(id: number, emailResquest: any): Observable<MicroResponse<string>> {
    return this._http.post<MicroResponse<string>>(
      this.userMicroservice + '/' + id + '/email',
      emailResquest,
    );
  }

  searchUpdate(
    cedula: string,
    password: string,
  ): Observable<MicroResponse<any>> {
    return this.getIdentificationByCard(cedula).pipe(
      switchMap(response => {
        return this.getUserByIdentificationId(response.data.id).pipe(
          switchMap((userResponse: MicroResponse<UserResponse>) => {
            const params: any = userResponse.data;
            const userRequest: UserRequest = params;
            userRequest.password = password;
            return this.updateUser(userRequest);
          }),
        );
      }),
    );
  }

  updatePasswordPin(
    idProcess: string,
    password: string,
    pin: string,
  ): Observable<MicroResponse<any>> {
    const request = { idProcess: idProcess, password: password, pinCode: pin };
    return this._http.put<MicroResponse<UserResponse>>(
      this.userMicroservice,
      request,
    );
  }

  searchIdentificationData(params: any): Observable<any> {
    return this._http.get<MicroResponse<UserResponse>>(
      `${this.userMicroservice}/${params}`,
    );
  }

  /* -------PARA VERIFICAR------- */

  cambiarEmail(params: any): Observable<any> {
    return this._http.put(`${this.resourceUrl}/cambiar-email`, params, {
      observe: 'response',
    });
  }

  checkRuc(ruc: string): Observable<any> {
    return this._http.get(
      `${environment.CEDULAS_URL}/rucs/find_by_ruc/elastic/${ruc}`,
      { observe: 'response' },
    );
  }

  // USERMICROSERVICE SERVICES

  getUserByEmail(username: string): Observable<MicroResponse<UserResponse>> {
    return this._http.get<MicroResponse<UserResponse>>(
      `${this.userMicroservice}?email=${username}`,
    );
  }

  getUserByIdentificationId(
    identificationId: any,
  ): Observable<MicroResponse<UserResponse>> {
    return (this.userResponse = this._http.get<MicroResponse<UserResponse>>(
      `${this.userMicroservice}?identificationId=${identificationId}`,
    ));
  }

  verifyUserCell(cellPhone: any): Observable<any> {
    return this._http.get(
      `${this.userMicroservice}/phone?telephone=${cellPhone}`,
    );
  }

  verifyUserEmail(email: any): Observable<any> {
    return this._http.get(this.userMicroservice + '/email?email=' + email);
  }

  verifyUserEmailPin(email: any, pinCode: any) {
    return this._http.get(
      this.userMicroservice +
        `/verifyPinCode?email=${email}&pincode=${pinCode}`,
    );
  }

  updateUser(userRequest: UserRequest): Observable<any> {
    return this._http.put<MicroResponse<UserResponse>>(
      this.userMicroservice,
      userRequest,
    );
  }

  getUserFilterByEmail(
    email: string,
  ): Observable<MicroResponse<SimpleResponse>> {
    return this._http.get<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/filter?email=${email}`,
    );
  }

  getValidationStatus(email: string) {
    return this._http.get<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/validations/${email}`,
    );
  }

  verifyPassword(
    idProcess: string,
    password: string,
  ): Observable<MicroResponse<SimpleResponse>> {
    const request = { idProcess: idProcess, password: password };
    return this._http.put<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/password`,
      request,
    );
  }

  verifyPin(
    idProcess: string,
    pinCode: string,
  ): Observable<MicroResponse<SimpleResponse>> {
    const request = { idProcess: idProcess, pinCode: pinCode };
    return this._http.put<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/pin`,
      request,
    );
  }

  sendAccountLockEmail(email: string): Observable<void> {
    return this._http.post<void>(`${this.userMicroservice}/email/message`, {
      subjectId: 1,
      data: { email },
    });
  }

  sendEmailAccess(email: string): Observable<void> {
    return this._http.post<void>(`${this.userMicroservice}/email/message`, {
      subjectId: 2,
      data: { email },
    });
  }

  checkUserProcess(id: string): Observable<MicroResponse<SimpleResponse>> {
    return this._http.get<MicroResponse<SimpleResponse>>(
      `${this.userMicroservice}/process?id=${id}`,
    );
  }

  lockUser(id: string): Observable<MicroResponse<LockResponse>> {
    return this._http.put<MicroResponse<LockResponse>>(
      `${this.userMicroservice}/account`,
      { id },
    );
  }

  getUserEconomicActivity(): Observable<
    MicroResponse<Array<EconomicActivityJson>>
  > {
    return this._http.get<MicroResponse<Array<EconomicActivityJson>>>(
      `${this.userMicroservice}/economic/activity`,
    );
  }

  // IDENTIFICATIONMICROSERVICE SERVICES

  getIdentificationById(
    identificationId: number,
  ): Observable<MicroResponse<IdentificationResponse>> {
    return this._http.get<MicroResponse<IdentificationResponse>>(
      `${this.identificationMicroservice}/${identificationId}`,
    );
  }

  getIdentificationByCard(
    cedula: string,
  ): Observable<MicroResponse<IdentificationResponse>> {
    return (this.identificationResponse = this._http.get<
      MicroResponse<IdentificationResponse>
    >(`${this.identificationMicroservice}?cardId=${cedula}`));
  }
}
